const isMultipleComparer = (comparer) =>
    comparer === 'in' || comparer === 'notin'

const toArray = (values) => {
    if (values === null || values === undefined) {
        return []
    }

    if (Array.isArray(values)) {
        return values
    }

    return [values]
}

const toMultipleArray = (values) => {
    if (typeof values === 'string') {
        return values
            .split(',')
            .map((value) => value.trim())
            .filter((value) => value !== '')
    }

    return toArray(values)
}

const normalizeAttributeValue = (value) => {
    if (value === null || value === undefined) {
        return null
    }

    if (typeof value === 'object') {
        if (value.value !== undefined && value.value !== null) {
            return { value: String(value.value) }
        }

        if (value.identifier !== undefined && value.identifier !== null) {
            return { value: String(value.identifier) }
        }

        return null
    }

    return { value: String(value) }
}

const normalizeContextValue = (value) => {
    if (value === null || value === undefined) {
        return null
    }

    if (typeof value !== 'object') {
        return { identifier: String(value) }
    }

    const normalized = {}

    if (value.ulid) {
        normalized.ulid = value.ulid
    }

    const identifier = value.identifier ?? value.value
    if (identifier !== undefined && identifier !== null && identifier !== '') {
        normalized.identifier = String(identifier)
    }

    if (Object.keys(normalized).length === 0) {
        return null
    }

    return normalized
}

export const normalizeCriteriaForSubmission = (criteria) => {
    if (!criteria) {
        return criteria
    }

    const normalized = {
        ...criteria,
    }

    if (criteria.comparer === 'isnull' || criteria.comparer === 'notnull') {
        normalized.values = null
        return normalized
    }

    const values = isMultipleComparer(criteria.comparer)
        ? toMultipleArray(criteria.values)
        : toArray(criteria.values)

    switch (criteria.selector) {
        case 'attribute': {
            const normalizedValues = values
                .map(normalizeAttributeValue)
                .filter((value) => value !== null)

            normalized.values = isMultipleComparer(criteria.comparer)
                ? normalizedValues
                : (normalizedValues[0] ?? null)
            return normalized
        }

        case 'context': {
            const normalizedValues = values
                .map(normalizeContextValue)
                .filter((value) => value !== null)

            normalized.values = isMultipleComparer(criteria.comparer)
                ? normalizedValues
                : (normalizedValues[0] ?? null)
            return normalized
        }

        default:
            return normalized
    }
}
